<template>
  <div class="flex justify-end w-full">
    <!-- MARK: Desktop -->
    <UNavigationMenu
      highlight
      variant="link"
      :items="links"
      :disable-click-trigger="false"
      :arrow="true"
      :ui="{
        childList: 'grid-cols-1',
        childLink:
          'text-base hover:before:bg-primary/20 data-[active]:before:bg-primary/10',
        link: 'font-medium text-base py-3 data-[active]:after:h-[3px]',
      }"
      class="hidden mx-auto xl:ml-6 xl:flex"
    />

    <div class="flex items-center justify-end flex-1">
      <div class="hidden md:block">
        <VButton
          trailing-icon="i-heroicons-arrow-right"
          :to="'/plattform'"
          class="flex justify-center px-5"
        >
          {{ $t('toThePortal') }}
        </VButton>
      </div>

      <!-- MARK: Mobile  -->
      <div class="xl:hidden ml-2">
        <TheNavigationMobileMenu
          v-model:open="isMobileMenuOpen"
          :items="mobileLinks"
        >
          <div class="md:hidden mt-2">
            <VButton
              trailing-icon="i-heroicons-arrow-right"
              :to="'/plattform'"
              :size="Size.sm"
              class="w-full justify-center"
            >
              {{ $t('toThePortal') }}
            </VButton>
          </div>
        </TheNavigationMobileMenu>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Size } from '@/types/enums'
import type { ArrayOrNested, NavigationMenuItem } from '@nuxt/ui'
import {
  companyDomainLinks,
  vehicleDomainLinks,
} from '@/constants/navigationLinks'

const { t } = useI18n()
const isMobileMenuOpen = ref(false)

const vehicleCategories = vehicleDomainLinks.map((v) => ({
  ...v,
  onSelect: () => (isMobileMenuOpen.value = false),
}))

const links = ref<ArrayOrNested<NavigationMenuItem>>([
  {
    label: t('rentIn', 2),
    children: vehicleCategories,
  },
  {
    label: t('rentOut'),
    to: '/vermieten',
    target: '_self',
  },
  {
    label: t('theFooter.company'),
    children: companyDomainLinks,
  },
])

const mobileLinks: ArrayOrNested<NavigationMenuItem> = [
  vehicleCategories,
  [
    ...companyDomainLinks,
    {
      label: t('rentOut'),
      to: '/vermieten',
      target: '_self',
    },
  ],
]
</script>
